/**
 * @Author: 左建
 * @Date: 2022/6/16 16:18
 * @LastEditTime: 2022/6/16 16:18
 * @Description: 管理端问卷接口
**/

import { get, post, postFormData } from "@/utils/request"

/**
 * 获取公共题库筛选菜单数据
 * @return {Promise<any>}
 **/
export function getCommonQlMenu () {
    return post("/Manage/Platform/GetSystemCategoryList")
}

// 增加问卷
export function addQuestion (data) {
    return post("/Manage/Questionnaire/AddOrEdit", undefined, undefined, data)
}

// 查询问卷列表（管理端）
export function getQuestionList (data) {
    return post("/Manage/Questionnaire/GetListForAdmin", data, true, data)
}

// 物理删除问卷
export function delQuestion (id) {
    const formData = new FormData()
    formData.append("id", id)
    return post("/Manage/Questionnaire/Delete", undefined, undefined, formData)
}

// 导出问卷
export function exportQuestion (id) {
    const formData = new FormData()
    formData.append("id", id)
    return post("/Manage/Questionnaire/ExportQuestionnaireToWord", undefined, undefined, formData)
}

// 获取回收站列表
export function getRecycleBinList (data) {
    return post("/Manage/Questionnaire/GetRecycleList", data, true, data)
}

// 恢复/假删除/彻底删除/禁用问卷
export function recycleQuestionnaire (data) {
    return post("/Manage/Questionnaire/Recycle", undefined, undefined, data)
}
// 获取问卷详情
export function getQuestionnaireDetail (id) {
    return post("/Manage/Questionnaire/GetById", { id }, undefined)
}

// 发布问卷
export function publishQuestionnaire (data) {
    return post("/Manage/Questionnaire/Publish", undefined, undefined, data)
}
// 导入问卷
export function importQuestionnaire (url) {
    return postFormData("/Manage/Questionnaire/ImportQuestionnaireFromWord", { url })
}
// 获取统计数据
export function getStatData (Qid) {
    return post("/Manage/Questionnaire/GetResult", { id: Qid })
}
